import { mapState, mapGetters } from 'vuex'
import { callApp } from '@/utils/mUtil'

export function wrapClick(fn, context) {
  return async function(...args) {
    // 确保 beforeClick 存在并执行
    if (typeof context.$beforeClick === 'function') {
      const shouldContinue = await context.$beforeClick();
      if (!shouldContinue) {
        return;
      }
    }
    return fn.apply(context, args);
  }
}

// 在 Vue 原型上添加统一的前置处理函数
export function installClickHandler(Vue) {
  Vue.prototype.$beforeClick = async function() {
    // 从 vuex 中获取登录状态
    const store = this.$store;
    const isLogin = store.getters.isLogin;
    const isMGTV = store.state.isMGTV;

    if (!isLogin) {
      if (isMGTV) {
        // 在芒果TV APP内，使用 MgtvApi.login
        MgtvApi.login(() => {
          location.reload();
        });
      } else {
        // APP外走引流下载流程
        callApp();
      }
      return false; // 返回 false 阻止后续操作
    }

    return true; // 已登录，继续执行
  };

  Vue.prototype.$wrapClick = function(fn) {
    return wrapClick(fn, this);
  };
}
